import { type RefObject, useEffect } from "react";

const SCROLL_PADDING = 8;

export function useScrollFrozenColumnFocus(
  scrollContainerRef: RefObject<HTMLDivElement | null>,
  frozenAnchorRef: RefObject<HTMLElement | null>,
): void {
  useEffect(() => {
    const container = scrollContainerRef.current;
    const frozenAnchor = frozenAnchorRef.current;

    if (!container || !frozenAnchor) return;

    const scrollContainer = container;
    const frozenColumnAnchor = frozenAnchor;

    function handleFocusIn(event: FocusEvent): void {
      const target = event.target;

      if (!(target instanceof HTMLElement)) return;

      const cell = target.closest("td, th");

      if (cell && window.getComputedStyle(cell).position === "sticky") return;

      requestAnimationFrame(() => {
        const targetLeft = target.getBoundingClientRect().left;
        const frozenRight = frozenColumnAnchor.getBoundingClientRect().right;

        if (targetLeft >= frozenRight) return;

        scrollContainer.scrollLeft -= frozenRight - targetLeft + SCROLL_PADDING;
      });
    }

    scrollContainer.addEventListener("focusin", handleFocusIn);

    return () => scrollContainer.removeEventListener("focusin", handleFocusIn);
  }, [scrollContainerRef, frozenAnchorRef]);
}
